import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export default function ViewResultsBox(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue} style={modalStyle}>
      <div style={iconContainerStyle}>
        <AssignmentTurnedInIcon style={successIconStyle} />
      </div>
      <Div margin={tenzero}>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Test Results
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Do you want to view the test results?
        </Text>
      </Div>
      <Div
        margin={tenzero}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <ModalButton onClick={props.handler1}>Cancel</ModalButton>
        <ModalButton onClick={props.handler2}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}

// Styling for modal components
const modalStyle = {
  width: "320px",
  padding: "20px",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
};

const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
